// removed by extract-text-webpack-plugin
module.exports = {"container":"_34aecd5078_src-comparableSales-_Tabs_container","addTab":"_03e3bd2256_src-comparableSales-_Tabs_addTab"};


//////////////////
// WEBPACK FOOTER
// ./src/comparableSales/Tabs.css
// module id = 1040
// module chunks = 0